<template>
  <div class="text-center">
    <img class="" :src="setImageUrl(options.image)" alt="">
    <p :class="options.classes">{{options.text}}</p>
  </div>
</template>

<script>
export default {
  name: 'empty-data',
  props: {
    options: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
  img, p {
    margin: 0 auto;
  }
</style>
